"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

// Component for declaratively managing event listeners for `window`
var WindowListener =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(WindowListener, _Component);

  function WindowListener(props) {
    var _this;

    (0, _classCallCheck2.default)(this, WindowListener);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WindowListener).call(this, props));

    _this._handler = function () {
      var _this$props;

      return (_this$props = _this.props).handler.apply(_this$props, arguments);
    }; // Always call current prop value


    return _this;
  }

  (0, _createClass2.default)(WindowListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _window = this.props._window;

      _window.addEventListener(this.props.eventName, this._handler);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.eventName !== nextProps.eventName;
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps) {
      var _window = this.props._window;

      _window.removeEventListener(this.props.eventName, this._handler);

      _window.addEventListener(nextProps.eventName, this._handler);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _window = this.props._window;

      _window.removeEventListener(this.props.eventName, this._handler);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return WindowListener;
}(_react.Component);

exports.default = WindowListener;
WindowListener.displayName = 'WindowListener';
WindowListener.propTypes = {
  eventName: _propTypes.default.string.isRequired,
  handler: _propTypes.default.func.isRequired,
  // Only for testing purposes
  _window: _propTypes.default.object.isRequired
};
WindowListener.defaultProps = {
  _window: window
};
module.exports = exports.default;